import React from "react";

const Holi = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M29.932 20.735c-.367-4.772-2.589-7.763-4.55-10.402C23.569 7.89 22 5.78 22 2.668a.668.668 0 00-1.055-.542c-2.944 2.106-5.4 5.657-6.258 9.044-.596 2.359-.675 5.01-.686 6.762-2.718-.581-3.334-4.648-3.34-4.692a.664.664 0 00-.951-.506c-.144.07-3.5 1.775-3.696 8.585-.013.226-.014.454-.014.68 0 6.617 5.383 12 12 12 .01 0 .019.002.027 0h.008c6.6-.019 11.965-5.395 11.965-12 0-.332-.068-1.264-.068-1.264zM18 32.665c-2.206 0-4-1.91-4-4.26 0-.08 0-.16.005-.26.027-.99.215-1.667.421-2.117.387.83 1.079 1.595 2.202 1.595a.666.666 0 00.666-.667c0-.95.02-2.044.256-3.032.21-.877.713-1.809 1.35-2.556.283.97.835 1.755 1.374 2.521.772 1.096 1.57 2.23 1.71 4.163.008.114.016.23.016.353 0 2.35-1.794 4.26-4 4.26z"
            fill={fill}
        />
    </svg>
);

export default Holi;